export { default as state } from "./state"
export { default as getters } from "./getters"
export { default as actions } from "./actions"
export { default as mutations } from "./mutations"

export const namespaced = true
